import { create } from 'zustand';

/** A Street View location, optionally pinned to a known panorama. */
interface StreetViewLocation {
  lat: number;
  lon: number;
  heading?: number;
  /** Panorama id from a coverage check — skips a second lookup when opening. */
  panoId?: string;
}

/** Street View overlay state. */
interface StreetViewState {
  /** Whether the panorama overlay is shown. */
  open: boolean;

  /** Current panorama location. */
  location: StreetViewLocation | null;

  /** True when opened automatically by a low-zoom dive (so it auto-closes on climb). */
  autoOpened: boolean;

  /** Open the panorama at a location (e.g. an address result or a low-zoom dive). */
  openAt: (location: StreetViewLocation, autoOpened?: boolean) => void;

  /** Close the panorama. */
  close: () => void;
}

/** Store driving the Street View overlay. */
export const useStreetViewStore = create<StreetViewState>((set) => ({
  open: false,
  location: null,
  autoOpened: false,

  openAt: (location, autoOpened = false) => set({ open: true, location, autoOpened }),
  close: () => set({ open: false, location: null, autoOpened: false }),
}));
